/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  InternalServerErrorResponse,
  ResolveShareToken200
} from '.././model'
import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * Public endpoint that resolves a short share token to the case details needed for login
 * @summary Resolve a share token to case details
 */
export const resolveShareToken = (
    token: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ResolveShareToken200>(
      {url: `https://api.app.usesky.ai/organizations/share/${token}`, method: 'GET', signal
    },
      options);
    }
  

export const getResolveShareTokenQueryKey = (token: string,) => {
    return [`https://api.app.usesky.ai/organizations/share/${token}`] as const;
    }

    
export const getResolveShareTokenQueryOptions = <TData = Awaited<ReturnType<typeof resolveShareToken>>, TError = void | InternalServerErrorResponse>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveShareToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getResolveShareTokenQueryKey(token);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof resolveShareToken>>> = ({ signal }) => resolveShareToken(token, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof resolveShareToken>>, TError, TData> & { queryKey: QueryKey }
}

export type ResolveShareTokenQueryResult = NonNullable<Awaited<ReturnType<typeof resolveShareToken>>>
export type ResolveShareTokenQueryError = void | InternalServerErrorResponse

/**
 * @summary Resolve a share token to case details
 */
export const useResolveShareToken = <TData = Awaited<ReturnType<typeof resolveShareToken>>, TError = void | InternalServerErrorResponse>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveShareToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getResolveShareTokenQueryOptions(token,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



